export enum StudentEnrollmentStatus {
	ENROLLED = 'ENROLLED',
	COMPLETED = 'COMPLETED',
	DROPPED = 'DROPPED',
	IN_PROGRESS = 'IN_PROGRESS'
}

export enum StudentTopicProgressStatus {
	NOT_STARTED = 'NOT_STARTED',
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETED = 'COMPLETED'
}